<template>
	<div class="pt-4">
		<!-- tabs -->
		<v-tabs
			v-model="tab"
			:active-class="!$vuetify.theme.dark ? 'secondary-bg' : 'white'"
		>
			<v-tab
				:disabled="loading"
				class="text-capitalize"
				:to="{
					name: 'task-papers'
				}"
			>
				Tasks
			</v-tab>

			<v-tab
				:disabled="loading"
				class="text-capitalize"
				:to="{
					name: 'task-matching'
				}"
			>
				Validate
			</v-tab>
		</v-tabs>
		<v-divider/>

		<router-view />
		
	</div>
</template>

<script>
export default {
	data () {
		return {
			tab: 0,
			loading: false
		}
	},

	watch: {
		tab (val) {
			if (val === 0) {
				this.$router.replace({
					name: 'task-papers'
				})
			}
		}
	}
}
</script>
